{
    "@base-ui/react@1.3.0": {
        "licenses": "MIT",
        "repository": "https://github.com/mui/base-ui",
        "licenseUrl": "https://github.com/mui/base-ui/raw/master/LICENSE",
        "parents": "appler.dev"
    },
    "@fontsource-variable/geist@5.2.8": {
        "licenses": "OFL-1.1",
        "repository": "https://github.com/fontsource/font-files",
        "licenseUrl": "https://github.com/fontsource/font-files/raw/master/LICENSE",
        "parents": "appler.dev"
    },
    "@sentry/react@10.48.0": {
        "licenses": "MIT",
        "repository": "https://github.com/getsentry/sentry-javascript",
        "licenseUrl": "https://github.com/getsentry/sentry-javascript/raw/master/LICENSE",
        "parents": "appler.dev"
    },
    "@tailwindcss/vite@4.2.2": {
        "licenses": "MIT",
        "repository": "https://github.com/tailwindlabs/tailwindcss",
        "licenseUrl": "https://github.com/tailwindlabs/tailwindcss/raw/master/LICENSE",
        "parents": "appler.dev"
    },
    "@xmldom/xmldom@0.9.9": {
        "licenses": "MIT",
        "repository": "https://github.com/xmldom/xmldom",
        "licenseUrl": "https://github.com/xmldom/xmldom/raw/master/LICENSE",
        "parents": "appler.dev"
    },
    "axios@1.15.0": {
        "licenses": "MIT",
        "repository": "https://github.com/axios/axios",
        "licenseUrl": "https://github.com/axios/axios/raw/master/LICENSE",
        "parents": "appler.dev"
    },
    "bignumber.js@8.1.1": {
        "licenses": "MIT",
        "repository": "https://github.com/MikeMcl/bignumber.js",
        "licenseUrl": "https://github.com/MikeMcl/bignumber.js/raw/master/LICENCE",
        "parents": "appler.dev"
    },
    "bootstrap@5.3.8": {
        "licenses": "MIT",
        "repository": "https://github.com/twbs/bootstrap",
        "licenseUrl": "https://github.com/twbs/bootstrap/raw/master/LICENSE",
        "parents": "appler.dev"
    },
    "caniuse-lite@1.0.30001774": {
        "licenses": "CC-BY-4.0",
        "repository": "https://github.com/browserslist/caniuse-lite",
        "licenseUrl": "https://github.com/browserslist/caniuse-lite/raw/master/LICENSE",
        "parents": "appler.dev"
    },
    "class-variance-authority@0.7.1": {
        "licenses": "Apache-2.0",
        "repository": "https://github.com/joe-bell/cva",
        "licenseUrl": "https://github.com/joe-bell/cva/raw/master/LICENSE",
        "parents": "appler.dev"
    },
    "clsx@2.1.1": {
        "licenses": "MIT",
        "repository": "https://github.com/lukeed/clsx",
        "licenseUrl": "https://github.com/lukeed/clsx/raw/master/license",
        "parents": "appler.dev"
    },
    "color@3.2.1": {
        "licenses": "MIT",
        "repository": "https://github.com/Qix-/color",
        "licenseUrl": "https://github.com/Qix-/color/raw/master/LICENSE",
        "parents": "appler.dev"
    },
    "convert-units@2.3.4": {
        "licenses": "MIT",
        "repository": "https://github.com/ben-ng/convert-units",
        "licenseUrl": "https://github.com/ben-ng/convert-units/raw/master/LICENSE",
        "parents": "appler.dev"
    },
    "copy-to-clipboard@3.3.3": {
        "licenses": "MIT",
        "repository": "https://github.com/sudodoki/copy-to-clipboard",
        "licenseUrl": "https://github.com/sudodoki/copy-to-clipboard/raw/master/LICENSE",
        "parents": "appler.dev"
    },
    "country-telephone-code@0.2.0": {
        "licenses": "MIT",
        "repository": "https://github.com/mehcode/country-telephone-code",
        "licenseUrl": "https://github.com/mehcode/country-telephone-code/raw/master/LICENSE",
        "parents": "appler.dev"
    },
    "cron-parser@2.18.0": {
        "licenses": "MIT",
        "repository": "https://github.com/harrisiirak/cron-parser",
        "licenseUrl": "https://github.com/harrisiirak/cron-parser/raw/master/LICENSE",
        "parents": "appler.dev"
    },
    "csvtojson@2.0.14": {
        "licenses": "MIT",
        "repository": "https://github.com/Keyang/node-csvtojson",
        "licenseUrl": "https://github.com/Keyang/node-csvtojson/raw/master/LICENSE",
        "parents": "appler.dev"
    },
    "dot-prop@4.2.0": {
        "licenses": "MIT",
        "repository": "https://github.com/sindresorhus/dot-prop",
        "licenseUrl": "https://github.com/sindresorhus/dot-prop/raw/master/license",
        "parents": "appler.dev"
    },
    "highlight.js@11.11.1": {
        "licenses": "BSD-3-Clause",
        "repository": "https://github.com/highlightjs/highlight.js",
        "licenseUrl": "https://github.com/highlightjs/highlight.js/raw/master/LICENSE",
        "parents": "appler.dev"
    },
    "html-colors@0.0.6": {
        "licenses": "MIT",
        "repository": "https://github.com/radiovisual/html-colors",
        "licenseUrl": "https://github.com/radiovisual/html-colors/raw/master/license",
        "parents": "appler.dev"
    },
    "html-entities@1.2.1": {
        "licenses": "MIT",
        "repository": "https://github.com/mdevils/node-html-entities",
        "licenseUrl": "https://github.com/mdevils/node-html-entities/raw/master/LICENSE",
        "parents": "appler.dev"
    },
    "human-time@0.0.2": {
        "licenses": "MIT",
        "repository": "https://github.com/bahamas10/human",
        "licenseUrl": "https://github.com/bahamas10/human",
        "parents": "appler.dev"
    },
    "i18n-iso-countries@3.7.8": {
        "licenses": "MIT",
        "repository": "https://github.com/michaelwittig/node-i18n-iso-countries",
        "licenseUrl": "https://github.com/michaelwittig/node-i18n-iso-countries/raw/master/LICENSE",
        "parents": "appler.dev"
    },
    "ip@2.0.1": {
        "licenses": "MIT",
        "repository": "http://github.com/indutny/node-ip",
        "licenseUrl": "http://github.com/indutny/node-ip",
        "parents": "appler.dev"
    },
    "iso-country-currency@0.3.4": {
        "licenses": "ISC",
        "parents": "appler.dev"
    },
    "jq-web@0.6.2": {
        "licenses": "ISC",
        "repository": "https://github.com/fiatjaf/jq-web",
        "licenseUrl": "https://github.com/fiatjaf/jq-web/raw/master/LICENSE",
        "parents": "appler.dev"
    },
    "jsbarcode@3.12.3": {
        "licenses": "MIT",
        "repository": "https://github.com/lindell/JsBarcode",
        "licenseUrl": "https://github.com/lindell/JsBarcode/raw/master/MIT-LICENSE.txt",
        "parents": "appler.dev"
    },
    "jsonpath-plus@10.4.0": {
        "licenses": "MIT",
        "repository": "https://github.com/s3u/JSONPath",
        "licenseUrl": "https://github.com/s3u/JSONPath/raw/master/LICENSE",
        "parents": "appler.dev"
    },
    "jsonwebtoken@9.0.3": {
        "licenses": "MIT",
        "repository": "https://github.com/auth0/node-jsonwebtoken",
        "licenseUrl": "https://github.com/auth0/node-jsonwebtoken/raw/master/LICENSE",
        "parents": "appler.dev"
    },
    "katex@0.10.1": {
        "licenses": "MIT",
        "repository": "https://github.com/KaTeX/KaTeX",
        "licenseUrl": "https://github.com/KaTeX/KaTeX/raw/master/LICENSE",
        "parents": "appler.dev"
    },
    "lorem-ipsum@2.0.8": {
        "licenses": "ISC",
        "repository": "https://github.com/knicklabs/node-lorem-ipsum",
        "licenseUrl": "https://github.com/knicklabs/node-lorem-ipsum/raw/master/LICENSE",
        "parents": "appler.dev"
    },
    "lru-cache@5.1.1": {
        "licenses": "ISC",
        "repository": "https://github.com/isaacs/node-lru-cache",
        "licenseUrl": "https://github.com/isaacs/node-lru-cache/raw/master/LICENSE",
        "parents": "appler.dev"
    },
    "lucide-react@1.8.0": {
        "licenses": "ISC",
        "repository": "https://github.com/lucide-icons/lucide",
        "licenseUrl": "https://github.com/lucide-icons/lucide/raw/master/LICENSE",
        "parents": "appler.dev"
    },
    "luxon@1.28.1": {
        "licenses": "MIT",
        "repository": "https://github.com/moment/luxon",
        "licenseUrl": "https://github.com/moment/luxon/raw/master/license.md",
        "parents": "appler.dev"
    },
    "markdown-it-github-headings@2.0.1": {
        "licenses": "ISC",
        "repository": "https://github.com/Flet/markdown-it-github-headings",
        "licenseUrl": "https://github.com/Flet/markdown-it-github-headings/raw/master/LICENSE.md",
        "parents": "appler.dev"
    },
    "markdown-it@14.3.0": {
        "licenses": "MIT",
        "repository": "https://github.com/markdown-it/markdown-it",
        "licenseUrl": "https://github.com/markdown-it/markdown-it/raw/master/LICENSE",
        "parents": "appler.dev"
    },
    "marked@9.1.6": {
        "licenses": "MIT",
        "repository": "https://github.com/markedjs/marked",
        "licenseUrl": "https://github.com/markedjs/marked/raw/master/LICENSE.md",
        "parents": "appler.dev"
    },
    "mersenne-twister@1.1.0": {
        "licenses": "MIT",
        "repository": "https://github.com/boo1ean/mersenne-twister",
        "licenseUrl": "https://github.com/boo1ean/mersenne-twister",
        "parents": "appler.dev"
    },
    "moment@2.30.1": {
        "licenses": "MIT",
        "repository": "https://github.com/moment/moment",
        "licenseUrl": "https://github.com/moment/moment/raw/master/LICENSE",
        "parents": "appler.dev"
    },
    "node-forge@1.4.0": {
        "licenses": "(BSD-3-Clause OR GPL-2.0)",
        "repository": "https://github.com/digitalbazaar/forge",
        "licenseUrl": "https://github.com/digitalbazaar/forge/raw/master/LICENSE",
        "parents": "appler.dev"
    },
    "node-html-parser@1.1.15": {
        "licenses": "MIT",
        "repository": "https://github.com/taoqf/node-fast-html-parser",
        "licenseUrl": "https://github.com/taoqf/node-fast-html-parser",
        "parents": "appler.dev"
    },
    "papaparse@5.5.3": {
        "licenses": "MIT",
        "repository": "https://github.com/mholt/PapaParse",
        "licenseUrl": "https://github.com/mholt/PapaParse/raw/master/LICENSE",
        "parents": "appler.dev"
    },
    "qrcode@1.5.4": {
        "licenses": "MIT",
        "repository": "https://github.com/soldair/node-qrcode",
        "licenseUrl": "https://github.com/soldair/node-qrcode/raw/master/license",
        "parents": "appler.dev"
    },
    "react-bootstrap-typeahead@6.4.1": {
        "licenses": "MIT",
        "repository": "https://github.com/ericgio/react-bootstrap-typeahead",
        "licenseUrl": "https://github.com/ericgio/react-bootstrap-typeahead/raw/master/LICENSE.md",
        "parents": "appler.dev"
    },
    "react-bootstrap@2.10.10": {
        "licenses": "MIT",
        "repository": "https://github.com/react-bootstrap/react-bootstrap",
        "licenseUrl": "https://github.com/react-bootstrap/react-bootstrap/raw/master/LICENSE",
        "parents": "appler.dev"
    },
    "react-clock@2.3.0": {
        "licenses": "MIT",
        "repository": "https://github.com/wojtekmaj/react-clock",
        "licenseUrl": "https://github.com/wojtekmaj/react-clock/raw/master/LICENSE",
        "parents": "appler.dev"
    },
    "react-country-flag@3.1.0": {
        "licenses": "MIT",
        "parents": "appler.dev"
    },
    "react-datepicker@9.1.0": {
        "licenses": "MIT",
        "repository": "https://github.com/Hacker0x01/react-datepicker",
        "licenseUrl": "https://github.com/Hacker0x01/react-datepicker/raw/master/LICENSE",
        "parents": "appler.dev"
    },
    "react-dom@19.2.5": {
        "licenses": "MIT",
        "repository": "https://github.com/facebook/react",
        "licenseUrl": "https://github.com/facebook/react/raw/master/LICENSE",
        "parents": "appler.dev"
    },
    "react-dropzone@10.1.3": {
        "licenses": "MIT",
        "repository": "https://github.com/react-dropzone/react-dropzone",
        "licenseUrl": "https://github.com/react-dropzone/react-dropzone/raw/master/LICENSE",
        "parents": "appler.dev"
    },
    "react-feather@2.0.10": {
        "licenses": "MIT",
        "repository": "https://github.com/feathericons/react-feather",
        "licenseUrl": "https://github.com/feathericons/react-feather/raw/master/LICENSE",
        "parents": "appler.dev"
    },
    "react-hotkeys@2.0.0": {
        "licenses": "ISC",
        "repository": "https://github.com/greena13/react-hotkeys",
        "licenseUrl": "https://github.com/greena13/react-hotkeys/raw/master/LICENSE",
        "parents": "appler.dev"
    },
    "react-html-parser@2.0.2": {
        "licenses": "MIT",
        "repository": "https://github.com/wrakky/react-html-parser",
        "licenseUrl": "https://github.com/wrakky/react-html-parser/raw/master/LICENSE.md",
        "parents": "appler.dev"
    },
    "react-resizable-panels@4.10.0": {
        "licenses": "MIT",
        "repository": "https://github.com/bvaughn/react-resizable-panels",
        "licenseUrl": "https://github.com/bvaughn/react-resizable-panels/raw/master/LICENSE.md",
        "parents": "appler.dev"
    },
    "react-router-dom@7.14.0": {
        "licenses": "MIT",
        "repository": "https://github.com/remix-run/react-router",
        "licenseUrl": "https://github.com/remix-run/react-router/raw/master/LICENSE.md",
        "parents": "appler.dev"
    },
    "react@19.2.5": {
        "licenses": "MIT",
        "repository": "https://github.com/facebook/react",
        "licenseUrl": "https://github.com/facebook/react/raw/master/LICENSE",
        "parents": "appler.dev"
    },
    "recharts@3.8.1": {
        "licenses": "MIT",
        "repository": "https://github.com/recharts/recharts",
        "licenseUrl": "https://github.com/recharts/recharts/raw/master/LICENSE",
        "parents": "appler.dev"
    },
    "sax@1.2.4": {
        "licenses": "ISC",
        "repository": "https://github.com/isaacs/sax-js",
        "licenseUrl": "https://github.com/isaacs/sax-js/raw/master/LICENSE",
        "parents": "appler.dev"
    },
    "shadcn@4.2.0": {
        "licenses": "MIT",
        "repository": "https://github.com/shadcn-ui/ui",
        "licenseUrl": "https://github.com/shadcn-ui/ui/raw/master/LICENSE.md",
        "parents": "appler.dev"
    },
    "sql-formatter@2.3.2": {
        "licenses": "MIT",
        "repository": "https://github.com/zeroturnaround/sql-formatter",
        "licenseUrl": "https://github.com/zeroturnaround/sql-formatter/raw/master/LICENSE",
        "parents": "appler.dev"
    },
    "suncalc@1.9.0": {
        "licenses": "BSD*",
        "repository": "https://github.com/mourner/suncalc",
        "licenseUrl": "https://github.com/mourner/suncalc/raw/master/LICENSE",
        "parents": "appler.dev"
    },
    "tailwind-merge@3.5.0": {
        "licenses": "MIT",
        "repository": "https://github.com/dcastil/tailwind-merge",
        "licenseUrl": "https://github.com/dcastil/tailwind-merge/raw/master/LICENSE.md",
        "parents": "appler.dev"
    },
    "tailwindcss@4.2.2": {
        "licenses": "MIT",
        "repository": "https://github.com/tailwindlabs/tailwindcss",
        "licenseUrl": "https://github.com/tailwindlabs/tailwindcss/raw/master/LICENSE",
        "parents": "appler.dev"
    },
    "timezones.json@1.7.2": {
        "licenses": "MIT",
        "repository": "https://github.com/dmfilipenko/timezones.json",
        "licenseUrl": "https://github.com/dmfilipenko/timezones.json/raw/master/LICENSE",
        "parents": "appler.dev"
    },
    "tw-animate-css@1.4.0": {
        "licenses": "MIT",
        "repository": "https://github.com/Wombosvideo/tw-animate-css",
        "licenseUrl": "https://github.com/Wombosvideo/tw-animate-css/raw/master/LICENSE",
        "parents": "appler.dev"
    },
    "typeset-p@0.1.2": {
        "licenses": "MIT",
        "repository": "https://github.com/appler1009/typeset-p",
        "licenseUrl": "https://github.com/appler1009/typeset-p/raw/master/LICENSE",
        "parents": "appler.dev"
    },
    "uuid@3.3.2": {
        "licenses": "MIT",
        "repository": "https://github.com/kelektiv/node-uuid",
        "licenseUrl": "https://github.com/kelektiv/node-uuid/raw/master/LICENSE.md",
        "parents": "appler.dev"
    },
    "wabt@1.0.39": {
        "licenses": "Apache-2.0",
        "repository": "https://github.com/AssemblyScript/wabt.js",
        "licenseUrl": "https://github.com/AssemblyScript/wabt.js/raw/master/LICENSE",
        "parents": "appler.dev"
    },
    "xpath@0.0.27": {
        "licenses": "MIT",
        "repository": "https://github.com/goto100/xpath",
        "licenseUrl": "https://github.com/goto100/xpath",
        "parents": "appler.dev"
    }
}
